<div class="p-grid">
	<div class="p-col-12">
		<div id="order-tabs-container" class="p-grid order-tabs">
			<div
				class="order-tab order-tab-new col-6 p-md-3"
				(click)="changeDataset('orderType'); chart.refresh()"
				data-label="New Orders"
				data-index="0"
				data-stroke="#BBDEFB"
				data-fill="rgba(100, 181, 246, 0.2)"
			>
				<i class="pi pi-plus-circle"></i>
				<span class="order-label">Order Types</span>
				<i class="stat-detail-icon icon-arrow-right-circle"></i>
				<img src="assets/demo/images/dashboard/graph-blue.svg" alt="diamond-ng" />
			</div>
			<div
				class="order-tab order-tab-completed col-6 p-md-3"
				(click)="changeDataset('reportGroup'); chart.refresh()"
				data-label="Completed Orders"
				data-index="1"
				data-stroke="#C5CAE9"
				data-fill="rgba(121, 134, 203, 0.2)"
			>
				<i class="pi pi-check-circle"></i>
				<span class="order-label">Report Groups</span>
				<i class="stat-detail-icon icon-arrow-right-circle"></i>
				<img src="assets/demo/images/dashboard/graph-purple.svg" alt="diamond-ng" />
			</div>
			<div
				class="order-tab order-tab-refunded col-6 p-md-3"
				(click)="changeDataset('salesVLabor'); chart.refresh()"
				data-label="Refunded Orders"
				data-index="2"
				data-stroke="#B2DFDB"
				data-fill="rgba(224, 242, 241, 0.5)"
			>
				<i class="pi pi-refresh"></i>
				<span class="order-label">Sales vs Labor</span>
				<i class="stat-detail-icon icon-arrow-right-circle"></i>
				<img src="assets/demo/images/dashboard/graph-green.svg" alt="diamond-ng" />
			</div>
			<div
				class="order-tab order-tab-cancelled col-6 p-md-3"
				(click)="changeDataset('ppcPpa'); chart.refresh()"
				data-label="Cancelled Orders"
				data-index="3"
				data-stroke="#B2EBF2"
				data-fill="rgba(224, 247, 250, 0.5)"
			>
				<i class="pi pi-times-circle"></i>
				<span class="order-label">PPC/PPA</span>
				<i class="stat-detail-icon icon-arrow-right-circle"></i>
				<img src="assets/demo/images/dashboard/graph-red.svg" alt="diamond-ng" />
			</div>
		</div>
	</div>
	<div class="p-col-12">
		<div class="overview-chart">
			<p-chart #chart type="line" [data]="orderChartData" [options]="orderChartOptions" id="order-chart"> </p-chart>
		</div>
	</div>
</div>
